module.exports = __webpack_public_path__ + "static/img/health-benefits.47fa5e9e.png";